export default "__VITE_ASSET__O7P_I2HA__"